module.exports = __webpack_public_path__ + "img/img-saveManage.24b27b67.png";